import {
  httpRequest,
  querystringBuilderByObject
} from '@common/util/api-common.util';

export default class SolicitacaoApi {
  static get (params, pagina) {
    const query = querystringBuilderByObject({
      ...params,
      pagina,
      tamanho: 20
    });
    return httpRequest(`laudo-solicitacoes${query}`).then(json => json);
  }
  static getTotalSolicitados () {
    return httpRequest(`laudo-solicitacoes/qtd-solicitados`).then(
      json => json.data
    );
  }
  static post (body) {
    return httpRequest(`laudo-solicitacoes`, 'POST', body).then(
      json => json.data
    );
  }
  static put (body) {
    return httpRequest(`laudo-solicitacoes`, 'PUT', body).then(
      json => json.data
    );
  }
  static getLaudos (pagina, params) {
    const query = querystringBuilderByObject(params);
    return httpRequest(`laudos/${pagina}/20${query}`).then(json => json.data);
  }
  static getFrascos (laudo) {
    return httpRequest(`laudos/${laudo}/frascos`).then(json => json.data);
  }
  static getBlocos (laudo) {
    return httpRequest(`laudos/${laudo}/blocos`).then(json => json.data);
  }
}



// WEBPACK FOOTER //
// ./src/pages/solicitacao/solicitacao.api.js